import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row } from "react-flexbox-grid";

export default class DojoRow extends Component {
  render() {
    const { style = {}, children, ...rest } = this.props;

    const rowStyles = {
      marginTop: "0",
      marginRight: "0",
      marginBottom: "0",
      marginLeft: "0",
      ...style,
    };

    return (
      <Row style={rowStyles} {...rest}>
        {children}
      </Row>
    );
  }
}

DojoRow.propTypes = {
  style: PropTypes.object,
};
